import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 16"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"i-1230992083__a\"><path fill=\"#163e4d\" d=\"M0 0h25.921v14.441H0z\" data-name=\"Rettangolo 79\"></path></clipPath></defs><g data-name=\"Raggruppa 141\"><path fill=\"none\" d=\"M0 0h28v16H0z\" data-name=\"Rettangolo 127\"></path><g data-name=\"Raggruppa 140\"><g clip-path=\"url(#i-1230992083__a)\" data-name=\"Raggruppa 80\" transform=\"translate(1.039 .779)\"><path fill=\"currentColor\" d=\"m25.888 7.221.033-.747h-.035v-.105h-.159A7.416 7.416 0 0 1 18.169 0l-1.584.225a8.99 8.99 0 0 0 3.783 6.144H0v1.6h20.538a9 9 0 0 0-3.953 6.248l1.584.225a7.407 7.407 0 0 1 7.682-6.37v-.1h.066Z\" data-name=\"Tracciato 167\"></path></g></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "right-arrow"}) } }